import React, { ReactElement } from "react";

import { Stack, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";

import ClusterIdField from "@/components/ClusterIdField";
import SettingSection from "@/components/SettingSection";

// ClusterInfo shows read-only cluster metadata (currently just the
// cluster id) at the top of the Settings page. It renders for both
// standard and hosted clusters so users always have a single, obvious
// place to find the id — motivated by ENG-2375 (copying cluster_id
// into a terraform-provider-pomerium-zero config).
//
// The id MUST be sourced from the cluster object that the parent
// settings page has already loaded (and gated on), not from
// state.current.clusterId, which is updated immediately from the URL
// and can briefly race ahead of the form's loaded state during a
// cluster switch. Passing the prop keeps the displayed id in sync
// with the rest of the form.
export type ClusterInfoProps = {
  clusterId: string;
};

export const ClusterInfo = ({ clusterId }: ClusterInfoProps): ReactElement => {
  return (
    <Container component={Paper} maxWidth={false} disableGutters={true}>
      <Stack spacing={1} sx={{ m: 3 }}>
        <Typography id="cluster" variant="h2" sx={{ pt: 2 }}>
          Cluster
        </Typography>
        <Divider />
        <SettingSection label="Cluster ID">
          <ClusterIdField clusterId={clusterId} />
        </SettingSection>
      </Stack>
    </Container>
  );
};

export default ClusterInfo;
